import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import {
  SearchCurrencyrates,
  SearchCurrencyratesVariables
} from "./types/SearchCurrencyrates";

export const searchCurrencyrates = gql`
  ${pageInfoFragment}
  query SearchCurrencyrates($after: String, $first: Int!, $query: String!) {
    search: currencyrates(
      after: $after
      first: $first
      filter: { search: $query }
    ) {
      edges {
        node {
          id
          code
          name
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<
  SearchCurrencyrates,
  SearchCurrencyratesVariables
>(searchCurrencyrates);
